import React, { useCallback } from 'react'

import Form from './Form'

export default function API({ action, step, onSave }) {
  const handleSubmit = useCallback(
    values => {
      return onSave(values)
    },
    [onSave]
  )

  const initialValues = {
    method: 'post',
    body: {
      type: 'json',
    },
    ...step,
  }

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={initialValues}
      action={action}
      stepId={step.id}
    />
  )
}
